// adding a comma before the last 2 digits of a number
// used in payouts page

export const centsToEuros = (cents: string) => {
  const characters = [];
  for (let i = 0; i < cents.length; i++) {
    characters.push(cents.charAt(i));
  }

  characters.splice(characters.length - 2, 0, ',');
  return characters.join('');
};
